import metrix from "../assets/metrix";

const app = metrix.initialize({
  appId: "tebbreqyziuctbg",
});

function logMetrixEvent(event) {
  if (event && typeof event == "string") app.sendEvent(event);
}

export { logMetrixEvent };
